var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { format, parseISO, subDays } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";
import translate from "./i18n/getTranslate";
import { k } from "./i18n";
import MPStorage from "@/services/LocalStorage";
import { countriesWithRegion, EUCountryLists } from "@/assets/data/countryVATs";
export var TIME_RANGES = {
    CUSTOM: "custom",
    DAY: "day",
    WEEK: "week",
    BI_WEEK: "bi-week",
    MONTH: "month"
};
export var DayPickerModes;
(function (DayPickerModes) {
    DayPickerModes["RANGE"] = "range";
    DayPickerModes["SINGLE"] = "single";
    DayPickerModes["MULTIPLE"] = "multiple";
    DayPickerModes["DEFAULT"] = "default";
})(DayPickerModes || (DayPickerModes = {}));
export var timeOptions = [
    {
        label: translate(k.INS_custom),
        value: TIME_RANGES.CUSTOM
    },
    {
        label: translate(k.INS_yesterday),
        value: TIME_RANGES.DAY,
        numberOfDays: 1
    },
    {
        label: translate(k.INS_lastWeek),
        value: TIME_RANGES.WEEK,
        numberOfDays: 7
    },
    {
        label: translate(k.INS_last2Weeks),
        value: TIME_RANGES.BI_WEEK,
        numberOfDays: 14
    },
    {
        label: translate(k.INS_lastMonth),
        value: TIME_RANGES.MONTH,
        numberOfDays: 30
    }
];
export var createSafeIndex = function (length, index) {
    if (index === void 0) { index = 999999999; }
    var div = index % (length || 1);
    return index - div;
};
// https://stackoverflow.com/questions/5999998/check-if-a-variable-is-of-function-type
export var isFunction = function (value) {
    return (value &&
        (Object.prototype.toString.call(value) === "[object Function]" ||
            "function" === typeof value ||
            value instanceof Function));
};
export var clearPhoneNUmber = function (maybePhoneNumber) {
    return maybePhoneNumber
        .replace(/^0+/, "")
        .split(/[ -.\+:;?!~,`"&|()<>{}\[\]\r\n/\\]+/)
        .join("");
};
export var phoneNumberValidator = function (maybePhoneNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var PhoneNumberUtil, phoneUtil, cleanedMaybePhoneNumber, number;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, import("google-libphonenumber")];
            case 1:
                PhoneNumberUtil = (_a.sent()).PhoneNumberUtil;
                phoneUtil = PhoneNumberUtil.getInstance();
                cleanedMaybePhoneNumber = "+".concat(clearPhoneNUmber(maybePhoneNumber));
                if (!(/^(\+521)/.test(cleanedMaybePhoneNumber) ||
                    /^(\+571)/.test(cleanedMaybePhoneNumber))) {
                    try {
                        number = phoneUtil.parseAndKeepRawInput(cleanedMaybePhoneNumber);
                        return [2 /*return*/, phoneUtil.isValidNumber(number)];
                    }
                    catch (err) {
                        return [2 /*return*/, false];
                    }
                }
                else {
                    return [2 /*return*/, true];
                }
                return [2 /*return*/];
        }
    });
}); };
export var getPayloadForPermissions = function (channels, selectedNumbers, sharedNumbers, partnerId) {
    var arrayOfSelectedNumbers = selectedNumbers.map(function (number) { return number.value; });
    var arrayOfSharedNumbers = sharedNumbers.map(function (number) { return number.value; });
    var filteredChannels = channels.filter(function (channel) {
        return arrayOfSelectedNumbers.includes(channel.channel.setupInfo.phoneNumber);
    });
    var permissionGrantNumbers = __spreadArray(__spreadArray([], __read(arrayOfSharedNumbers), false), __read(arrayOfSelectedNumbers), false);
    var revokeChannels = channels.filter(function (item) {
        return !permissionGrantNumbers.includes(item.channel.setupInfo.phoneNumber);
    });
    var payloadForPermissions = filteredChannels.map(function (channel) {
        return {
            partner_id: partnerId,
            channel_id: channel.channel.id,
            permission_granted: true
        };
    });
    return { newNumbers: payloadForPermissions, revokeChannels: revokeChannels };
};
/**
 * Sanitize a route path to prevent cross-origin navigation errors.
 * Strips protocol prefixes and collapses leading double slashes so the
 * browser never interprets the value as a protocol-relative or absolute URL.
 */
export var sanitizeRoutePath = function (path) {
    if (!path)
        return path;
    var sanitized = path.replace(/^https?:\/\/[^/]*/, "");
    sanitized = sanitized.replace(/^\/\/+/, "/");
    if (sanitized && !sanitized.startsWith("/")) {
        sanitized = "/" + sanitized;
    }
    return sanitized;
};
export var saveLastLocalization = function () {
    var _a;
    var pathname = (_a = sanitizeRoutePath(document.location.pathname)) !== null && _a !== void 0 ? _a : document.location.pathname;
    if (!pathname.startsWith("/dashboard/app/") &&
        !pathname.includes("/dashboard/sso")) {
        MPStorage.saveToLocalStorage(MPStorage.customKeys.LAST_LOCALIZTIONS, pathname);
    }
};
export var removeLastLocalization = function () {
    MPStorage.removeLastLocalizationFromLocalStorage();
};
export var truncateText = function (text, maxLength) {
    if (maxLength === void 0) { maxLength = 26; }
    if (text.length > maxLength) {
        return text.substring(0, maxLength - 3) + "...";
    }
    else {
        return text;
    }
};
export var formatPhoneNumber = function (phoneNumber) {
    try {
        if (!phoneNumber)
            return "";
        // at this point, we'd assume that all number passed is coming with the country code added already
        var _phoneNumber = String(phoneNumber).includes("+")
            ? String(phoneNumber)
            : "+".concat(phoneNumber);
        var phoneUtil = PhoneNumberUtil.getInstance();
        var number = phoneUtil.parseAndKeepRawInput(_phoneNumber, "");
        var formattedNumber = phoneUtil.format(number, PhoneNumberFormat.INTERNATIONAL);
        var countryCode = number.getCountryCode();
        return formattedNumber.replace("+".concat(countryCode), "(+".concat(countryCode, ")"));
    }
    catch (error) {
        // at this point there might be an issue with formatting the number
        // we just return original value that was passed
        return phoneNumber;
    }
};
export var getEUCountry = function (country) {
    var _a, _b, _c;
    var selectedEUCountry = EUCountryLists.find(function (eu) {
        var _a;
        return eu.value === (country === null || country === void 0 ? void 0 : country.toUpperCase()) ||
            ((_a = eu.label) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === (country === null || country === void 0 ? void 0 : country.toLowerCase());
    });
    var prefix = (_b = (_a = selectedEUCountry === null || selectedEUCountry === void 0 ? void 0 : selectedEUCountry.meta) === null || _a === void 0 ? void 0 : _a.vatCode) !== null && _b !== void 0 ? _b : (_c = selectedEUCountry === null || selectedEUCountry === void 0 ? void 0 : selectedEUCountry.meta) === null || _c === void 0 ? void 0 : _c.countryCode;
    return { selectedEUCountry: selectedEUCountry, prefix: prefix };
};
/**
 * @param date - Date in ISO format `"YYYY-MM-DD"` or `Date`.
 * @returns An ISO format date.
 */
export var getISODate = function (date) {
    return typeof date === "string" ? parseISO(date) : date;
};
/**
 * @param date - Date in ISO format `"YYYY-MM-DD"`.
 * @returns A Date Instance `new Date("1970-01-01T06:00:00.000Z")`.
 */
export var getDateInUTC = function (date) {
    var dateToString = parseISO(date);
    var dateInUTC = utcToZonedTime(dateToString, "UTC");
    return dateInUTC;
};
export var getDateRanges = function (timeRange, mode) {
    if (mode === void 0) { mode = DayPickerModes.RANGE; }
    if ((timeRange === null || timeRange === void 0 ? void 0 : timeRange.dateTo) &&
        (timeRange === null || timeRange === void 0 ? void 0 : timeRange.dateFrom) &&
        (timeRange === null || timeRange === void 0 ? void 0 : timeRange.value) === TIME_RANGES.CUSTOM) {
        var dateFromUTC = getISODate(timeRange === null || timeRange === void 0 ? void 0 : timeRange.dateFrom);
        var dateToUTC = getISODate(timeRange === null || timeRange === void 0 ? void 0 : timeRange.dateTo);
        return {
            dateFrom: format(dateFromUTC, "yyyy-MM-dd"),
            dateTo: format(dateToUTC, "yyyy-MM-dd")
        };
    }
    else if ((timeRange === null || timeRange === void 0 ? void 0 : timeRange.dateFrom) && mode === DayPickerModes.SINGLE) {
        var dateFromUTC = getISODate(timeRange === null || timeRange === void 0 ? void 0 : timeRange.dateFrom);
        return {
            dateFrom: format(dateFromUTC, "yyyy-MM-dd"),
            dateTo: format(dateFromUTC, "yyyy-MM-dd")
        };
    }
    else {
        var todayUTC = new Date(new Date().toISOString());
        var dateTo = subDays(todayUTC, 1);
        var numberOfDays = (timeRange === null || timeRange === void 0 ? void 0 : timeRange.numberOfDays) || 1;
        var dateFrom = subDays(dateTo, numberOfDays - 1);
        return {
            dateFrom: format(dateFrom, "yyyy-MM-dd"),
            dateTo: format(dateTo, "yyyy-MM-dd")
        };
    }
};
export var transformEmojiUnicode = function (emoji) {
    return emoji === null || emoji === void 0 ? void 0 : emoji.replace(/U\+/g, "").split(" ").join("-").toLowerCase();
};
export var getCountryRegion = function (country) {
    var _a;
    if (!country)
        return "NA";
    return ((_a = countriesWithRegion[country.toUpperCase()]) !== null && _a !== void 0 ? _a : "NA");
};
// Moved to its own leaf module so cookie readers stay importable under jest;
// re-exported here to keep existing imports working.
export { getCookieValue } from "./getCookieValue";
export var MINIMUM_BANK_TRANSFER_AMOUNT = 500;
//# sourceMappingURL=data:application/json;base64,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